import AnimatedPopup from "../core/AnimatedPopup";
import Strings from "../core/data/Strings";
import ResizableScene from "../core/ResizableScene";
import PlayerData from "../PlayerData";
import ARIA from "../utils/ARIA";
import Fonts from "../utils/Fonts";
import GameColors from "../utils/GameColors";
import Overlay from "../utils/Overlay";

export default class ConfirmResetPopup extends AnimatedPopup {
	private _onResize: () => void;

	private _onReset: () => void;
	private _onResetContext: CallbackContext;

	constructor(scene: ResizableScene, onReset?: () => void, onResetContext?: CallbackContext) {
		super(scene, 0, 0);

		this._onReset = onReset;
		this._onResetContext = onResetContext;

		const overlay = (this._overlay = new Overlay(scene, 0.01, "popupOverlay", 0xffffff));
		this.add(overlay);

		const popupContainer = (this._popupGroup = scene.add.container(0, 0));
		this.add(popupContainer);

		const background = scene.add.nineSlicedSprite(0, 0, "popupBG", 1000, 600, 50, 50, 50, 50, null, false);
		popupContainer.add(background);
		popupContainer.setSize(background.slicedWidth, background.slicedHeight);

		const header = scene.add.image(0, 0, "popupSmallHeader");
		const headerText = scene.add.text(0, 0, Strings.get("ConfirmResetHeader").toUpperCase(), {
			color: GameColors.WHITE,
			fontFamily: Fonts.MontserratBold,
			fontSize: "56px",
			align: "center",
		});
		popupContainer.add([header, headerText]);

		const descBacker = scene.add.image(0, 0, "popupTextBG");
		const desc = scene.add.text(0, 0, Strings.get("ConfirmResetMessage"), {
			color: GameColors.PURPLE,
			fontFamily: Fonts.MontserratBold,
			fontSize: "50px",
			align: "center",
		});
		popupContainer.add([descBacker, desc]);

		const noButton = scene.add.button(0, 0, "xBtn", 0, this.close, this, true);
		popupContainer.add(noButton);

		const yesButton = scene.add.button(0, 0, "checkBtn", 0, this.resetSaveData, this, true);
		popupContainer.add(yesButton);

		this._onResize = (): void => {
			scene.alignIn.Center(popupContainer, scene.viewport);
			// ScaleManager.ScaleBackgroundFromZone(overlay, scene.viewport);
			scene.alignIn.Center(overlay, scene.viewport);

			scene.alignIn.TopCenter(header, background, 0, 50);
			scene.alignIn.Center(headerText, header);

			scene.alignIn.Center(descBacker, background, 0, -50);
			scene.alignIn.Center(desc, descBacker);

			scene.alignIn.BottomCenter(yesButton, background, -150, 50);
			scene.alignIn.BottomCenter(noButton, background, 150, 50);
		};
		this.resize();

		const ariaLayer = "reset-confirm";
		headerText.setARIA(ariaLayer, true);
		desc.setARIA(ariaLayer);
		yesButton.setARIA("Yes", ariaLayer);
		noButton.setARIA("No", ariaLayer);
		ARIA.showLayer(ariaLayer, true);

		this.build();
	}

	resetSaveData(): void {
		PlayerData.Instance.reset();
		PlayerData.Instance.save();
		if (this._onReset) {
			if (this._onResetContext) this._onReset.call(this._onResetContext);
			else this._onReset();
		}
		this.close();
	}

	build(): void {
		this.scene.add.tween({
			targets: this._overlay,
			alpha: 0.8,
			duration: 400,
			ease: Phaser.Math.Easing.Quadratic.Out,
		});

		this.scene.add.tween({
			targets: this._popupGroup,
			y: { from: this._popupGroup.y + 1000, to: this._popupGroup.y },
			duration: 400,
			ease: Phaser.Math.Easing.Quadratic.Out,
		});
		this._popupGroup.y += 1000;
	}

	close(): void {
		this.scene.add.tween({
			targets: this._overlay,
			alpha: 0,
			duration: 400,
			ease: Phaser.Math.Easing.Quadratic.Out,
		});

		this.scene.add.tween({
			targets: this._popupGroup,
			y: { from: this._popupGroup.y, to: this._popupGroup.y + 1000 },
			duration: 400,
			ease: Phaser.Math.Easing.Back.In,
			onComplete: () => {
				ARIA.showLayer(ARIA.DEFAULT_LAYER, true);
				this.destroy();
			},
		});
	}

	resize(): void {
		super.resize();
		if (this._onResize) this._onResize();
	}
}
